/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { observable } from 'mobx';
import { PrebuiltEntityMetadata } from 'src/luis/projects/entities/types/PrebuiltEntityMetadata';
import { PrebuiltEntityStore } from 'src/luis/types/stores/entities/PrebuiltEntityMetadataStore';

/**
 * An prebuilt entity store factory function.
 *
 * @param prebuiltEntity The prebuilt entity data.
 * @returns A new instance of an prebuilt entity store.
 */
export const createPrebuiltEntityStore = (prebuiltEntity: PrebuiltEntityMetadata): PrebuiltEntityStore => {
    const prebuiltEntityStore: PrebuiltEntityStore = {
        id: '',
        name: prebuiltEntity.name,
        description: prebuiltEntity.description,
        examples: prebuiltEntity.examples
    };

    return observable(prebuiltEntityStore, { name: observable, description: observable, examples: observable }, { deep: false });
};
